<!-- Modal Backdrop -->
<div
    *ngIf="isVisible"
    class="tw-fixed tw-inset-0 tw-bg-black tw-bg-opacity-50 tw-z-50 tw-flex tw-items-center tw-justify-center tw-p-4"
    (click)="onBackdropClick($event)"
>
    <!-- Modal Content -->
    <div
        class="tw-bg-white tw-rounded-[20px] tw-shadow-2xl tw-max-w-[1152px] tw-w-full tw-max-h-[90vh] tw-overflow-y-auto tw-relative"
    >
        <!-- Close Button -->
        <button
            (click)="onClose()"
            class="tw-absolute tw-top-[20px] tw-right-[20px] tw-z-10 tw-w-[40px] tw-h-[40px] tw-bg-white tw-flex tw-items-center tw-justify-center hover:tw-bg-gray-50 tw-transition-colors"
        >
            <mat-icon class="tw-text-black tw-w-[18px] tw-h-[18px]"
                >close</mat-icon
            >
        </button>

        <!-- Modal Header -->
        <div class="tw-pt-[60px] tw-px-[20px] tw-pb-[5px]">
            <div class="tw-flex tw-flex-col tw-gap-[20px]">
                <span
                    class="tw-text-[20px] lg:tw-text-[32px] tw-font-bold tw-text-[#024B3F] tw-leading-[140%]"
                >
                    SME Success Stories
                </span>
                <span
                    class="tw-text-[18px] lg:tw-text-[28px] tw-font-semibold tw-text-[#000000] tw-leading-[140%]"
                >
                    {{ storyData?.articleTitle || storyData?.title }}
                </span>
            </div>
        </div>

        <!-- Modal Body -->
        <div class="tw-p-[20px] md:tw-p-[40px] md:tw-pt-0">
            <div class="tw-flex tw-flex-col tw-gap-[30px] tw-items-center">
                <!-- Image Section -->
                <div
                    class="tw-relative tw-w-full lg:tw-w-[564px] tw-h-[250px] lg:tw-h-[350px] tw-overflow-hidden tw-flex tw-flex-col tw-items-center tw-gap-0"
                >
                    <img
                        [src]="storyData?.aImageDesktop"
                        [alt]="storyData?.title"
                        class="tw-w-full tw-h-full tw-object-cover xl:tw-block tw-hidden"
                    />
                    <img
                        [src]="storyData?.aImagePortrait"
                        [alt]="storyData?.title"
                        class="tw-w-full tw-h-full tw-object-cover xl:tw-hidden md:tw-block tw-hidden"
                    />
                    <img
                        [src]="storyData?.aImageMobile"
                        [alt]="storyData?.title"
                        class="tw-w-full tw-h-full tw-object-cover md:tw-hidden tw-block"
                    />

                    <!-- Navigation Arrows -->
                    <!-- <button class="tw-absolute tw-left-[20px] tw-top-1/2 tw-transform -tw-translate-y-1/2 tw-w-[40px] tw-h-[40px] tw-bg-white tw-rounded-full tw-shadow-md tw-flex tw-items-center tw-justify-center tw-border tw-border-gray-200 hover:tw-bg-gray-50 tw-transition-colors">
            <mat-icon class="tw-text-gray-600">chevron_left</mat-icon>
          </button>
          <button class="tw-absolute tw-right-[20px] tw-top-1/2 tw-transform -tw-translate-y-1/2 tw-w-[40px] tw-h-[40px] tw-bg-white tw-rounded-full tw-shadow-md tw-flex tw-items-center tw-justify-center tw-border tw-border-gray-200 hover:tw-bg-gray-50 tw-transition-colors">
            <mat-icon class="tw-text-gray-600">chevron_right</mat-icon>
          </button> -->
                    <!-- <div class="tw-flex-1 tw-p-[14px] tw-bg-[#003A700D]">
                        <span
                            class="tw-text-[14px] tw-text-[#000000CC] tw-text-center tw-leading-[24px]"
                        >
                            Photo credit: imSME Lorem ipsum dolor sit amet,
                            consectetur adipiscing elit
                        </span>
                    </div> -->
                </div>

                <!-- Photo Credit -->

                <!-- Content Section -->
                <div class="tw-w-full">
                    <div
                        [innerHTML]="storyData?.description"
                        class="default-html"
                    ></div>
                </div>
            </div>
        </div>
    </div>
</div>
